import $ from 'jquery';

import BrIcons from '@components/BrIcons';

const hideAnimationRef = (row, columnIndex) => (e) => {
  if (e) {
    const rowContainer = $(e.parentElement);
    if (!rowContainer.is(':animated')) {
      rowContainer.animate({ opacity: 0 }, 2000, function () {
        if (columnIndex === 0) {
          // only perform the callback on the first cell
          // eslint-disable-next-line no-console
          console.log('animation complete!');
          // it will be up to calling app to handle behaviour after hiding animation completes
          // Calling App can either refresh datatable with new set of table
          // Or handle it through given callback function
          if (row.onHideAnimationComplete) {
            row.onHideAnimationComplete(row);
          }
        }
        // set the css back, otherwise the same row will still be hidden
        $(this).css('opacity', '1');
      });
    }
  }
};

export default function CellRenderer({ row, col, cell, columnIndex, rowIndex }) {
  return (
    <div
      className={`br-table-content-cell ${col.contentAlign || ''} row-${rowIndex}`}
      ref={row.startHideAnimation && hideAnimationRef(row, columnIndex)}
      data-id={`br-table-cell-${col.key}`}
    >
      {cell.isDisabled ? <BrIcons.Spinner /> : col.column({ row, col, cell })}
    </div>
  );
}
